<template>
  <v-dialog
    v-model="loginSignupForm"
    content-class="login_signup_form"
    transition="scale-transition"
    width="350"
    @keydown.esc="closePopup()"
    @update:returnValue="onPopupClose">
    <v-card>
      <v-toolbar card dark color="primary" >
        <v-toolbar-title v-if="!authenticated">Authentication</v-toolbar-title>
        <v-toolbar-title v-if="authenticated">Access right</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="closePopup()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <span v-if="!authenticated">Unlock this feature. Register for free or log in if you already have an account.</span>
        <span v-if="authenticated">
          It looks like you do not have access to this content.<br /><br />
          Give a look at our <a href="#" @click="goToAccessPage()">Access page</a> or get in touch with us through the live chat or through the <a href="#" @click="goToContactForm()">contact form</a>.
        </span>
      </v-card-text>
      <v-card-actions v-if="!authenticated">
        <v-spacer></v-spacer>
        <subscriptionForm subscriptionType='getDemoAccess' />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <v-btn flat class="primary" 
          @click="login()">Login</v-btn>
      </v-card-actions>
    </v-card>
    <ContactUsForm />
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import SubscriptionForm from '@/components/Subscription/SubscriptionForm'
import ContactUsForm from './ContactUsForm'

export default {
  name: 'LoginSignupForm',
  data () {
    return {
      subscriptionDialog: false,
    }
  },
  components: {
    SubscriptionForm,
    ContactUsForm
  },
  computed: {
    ...mapState(['loginSignupForm', 'authenticated']),
  },
  methods: {
    ...mapMutations(['setLoginSignupForm', 'setViewDialogContactUs']),
    login () {
      this.setLoginSignupForm(false)
      Vue.prototype.$auth0.login()
    },
    onPopupClose (event) {
      if (event === undefined) {
        this.closePopup()
      }
    },
    closePopup () {
      this.setLoginSignupForm(false)
    },
    goToAccessPage () {
      this.$router.push({ path: 'access' })
      this.closePopup()
    },
    goToContactForm () {
      this.setViewDialogContactUs(true)
      this.closePopup()
    }
  }
}
</script>
<style>

</style>
